(() => {
  'use strict';
  const origin='https://ke-tools-calculator-beta.ketools.workers.dev';
  const params=new URLSearchParams(location.search),preview=params.get('preview_theme_id');
  if(preview&&/^\d{1,20}$/.test(preview))document.querySelectorAll('a[data-ke-calculator-link]').forEach(link=>{
    const url=new URL(link.href,location.href);
    if(url.origin===location.origin&&url.searchParams.get('view')==='ke-schnittdaten'){url.searchParams.set('preview_theme_id',preview);link.href=url.href;}
  });
  document.querySelectorAll('iframe[data-ke-calculator-frame]').forEach(frame=>{
    const url=new URL(frame.src);if(url.origin!==origin)return;
    const family=params.get('family'),variant=params.get('variant');
    if(family&&/^vhm-[a-z-]{1,80}$/.test(family))url.searchParams.set('family',family);
    if(variant&&/^(?:gid:\/\/shopify\/ProductVariant\/)?\d{1,30}$/.test(variant))url.searchParams.set('variant',variant);
    if(frame.src!==url.href)frame.src=url.href;
    const fallback=frame.parentElement.querySelector('[data-ke-calculator-external]');
    if(fallback){const target=new URL(url);target.searchParams.delete('embedded');fallback.href=target.href;}
    window.addEventListener('message',event=>{
      const message=event.data;
      if(event.origin!==origin||event.source!==frame.contentWindow||!message||message.type!=='ke-calculator:height'||!Number.isSafeInteger(message.height)||message.height<600||message.height>12000)return;
      frame.style.height=message.height+'px';
    });
  });
})();
